var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['tip-message', { 'tip-message__block': _vm.block }]},[(_vm.html)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.getHtml())}}):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }